import { Fun, Pair, mk_widget, nothing, Option } from 'widgets-for-react'
import { List } from 'immutable'
import React from 'react'
import { Breadcrumb } from '../../wordpress/types_and_parser/extra_types.mod'
import { ParsedNode } from '../../wordpress/types_and_parser/types.ext.gen'
import { ContentType } from '../../public_site.main.mod'
import { Link } from 'react-router-dom'
import { toRelativeUrl } from '../../../helpers'
import { t } from "i18next";

export const page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType> = (page) => (blocks) => {
  return mk_widget({
    run: (o) => (
      <>
        <main className={`main main--default`}>
          <div className="main__inner gutter--m">
            <article className={`page page--${page.snd.v.kind == 'r' && page.snd.v.v.template == 'home' ? 'home' : ''}page`}>
              <div className="page__inner">
                <div className="page__content">
                  {page.snd.v.kind == 'r' &&
                    page.snd.v.v.breadcrumb &&
                    page.snd.v.v.breadcrumb.itemListElement.length > 1 && (
                      <nav className="breadcrumbs">
                        <div className="breadcrumbs__inner container--xl grid--gutter">
                          <ul className="breadcrumbs__list">
                            <li className="breadcrumbs__item">
                              <Link to={window.wp.language == 'en' ? "/en/2021/" : `/${window.wp.language}/2021/`} className="breadcrumbs__link typo--4xs">
                                Home
                              </Link>
                            </li>
                            {page.snd.v.v.breadcrumb.itemListElement.slice(1).map((item) =>
                              item.item['@id'] ? (
                                <li className="breadcrumbs__item">
                                  <Link to={toRelativeUrl(item.item['@id'])} className="breadcrumbs__link typo--4xs">
                                    {item.item.name}
                                  </Link>
                                </li>
                              ) : (
                                  <li className="breadcrumbs__item">
                                    <Link
                                      to={toRelativeUrl(window.location.href)}
                                      className="breadcrumbs__link typo--4xs"
                                    >
                                      {item.item.name}
                                    </Link>
                                  </li>
                                )
                            )}
                          </ul>
                        </div>
                      </nav>
                    )}
                  {blocks.run(o)}
                  {page.snd.v.kind == 'r' && page.snd.v.v.type && page.snd.v.v.type == 'news' && (
                    <section className="share">
                      <div className="share__inner container container--xs grid--gutter">
                        <h2 className="share__title typo--2xs">{t('share_link.title')}:</h2>
                        <ul className="socials">
                          <li className="socials__item">
                            <a
                              className="share__link socials__link share__link--facebook"
                              href={`http://www.facebook.com/share.php?u=${window.location.href}`}
                              target="_blank"
                              onClick={() => {
                                window.dataLayer.push({
                                  event: 'event.fccorporate',
                                  category: 'Social - Share',
                                  action: `http://www.facebook.com/share.php?u=${window.location.href}`,
                                  label: window.location.href,
                                })
                              }}
                            ></a>
                          </li>
                          <li className="socials__item">
                            <a
                              className="share__link socials__link share__link--twitter"
                              href={`http://twitter.com/home?status=${window.location.href}`}
                              target="_blank"
                              onClick={() => {
                                window.dataLayer.push({
                                  event: 'event.fccorporate',
                                  category: 'Social - Share',
                                  action: `http://twitter.com/home?status=${window.location.href}`,
                                  label: window.location.href,
                                })
                              }}
                            ></a>
                          </li>
                          <li className="socials__item">
                            <a
                              className="share__link socials__link share__link--linkedin"
                              href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}
                              target="_blank"
                              onClick={() => {
                                window.dataLayer.push({
                                  event: 'event.fccorporate',
                                  category: 'Social - Share',
                                  action: `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`,
                                  label: window.location.href,
                                })
                              }}
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </section>
                  )}
                  {page.snd.v.kind == 'r' &&
                    page.snd.v.v.type &&
                    page.snd.v.v.type == 'news' &&
                    page.snd.v.v.news_taxonomy.length > 0 ? (
                      <footer className="article__footer">
                        <ul className={`tags`}>
                          <li className={`tags__item tags__item--label`}>{t('news.categories')}</li>
                          {page.snd.v.v.news_taxonomy.map((term) => (
                            <li key={`news-${page.snd.v.v.id}-${term.slug}`} className={`tags__item`}>
                              <a
                                href={`${window.wp.language == 'en'
                                  ? '/frieslandcampina-news/'
                                  : window.wp.language == 'nl'
                                    ? '/nl/nieuws/'
                                    : '/de/frieslandcampina-news/'
                                  }?category=${term.term_id}`}
                              >
                                <span className={`tags__label`}>{term.name}</span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </footer>
                    ) : page.snd.v.kind == 'r' &&
                      page.snd.v.v.type &&
                      page.snd.v.v.type == 'story' &&
                      page.snd.v.v.story_taxonomy.length > 0 ? (
                        <footer className="article__footer">
                          <ul className={`tags`}>
                            <li className={`tags__item tags__item--label`}>{t('story.categories')}</li>
                            {page.snd.v.v.story_taxonomy.map((term) => (
                              <li key={`story-${page.snd.v.v.id}-${term.slug}`} className={`tags__item`}>
                                <a
                                  href={`${window.wp.language == 'en'
                                    ? '/our-stories/'
                                    : window.wp.language == 'nl'
                                      ? '/nl/onze-verhalen/'
                                      : '/de/' // cannot find the stories overview in german...
                                    }?category=${term.term_id}`}
                                >
                                  <span className={`tags__label`}>{term.name}</span>
                                </a>
                              </li>
                            ))}
                          </ul>
                        </footer>
                      ) : null}
                </div>
              </div>
            </article>
          </div>
        </main>
      </>
    ),
  })
}
